import React from 'react';
import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// project imports
import { store, persister } from 'store';
import api, { unauthorizedApiInstance } from 'api';
import { logout } from 'store/accountReducer';
import * as serviceWorker from 'serviceWorker';
import { aws4Interceptor } from 'aws4-axios';
import App from 'App';

// style + assets
import 'assets/scss/style.scss';

const interceptor = aws4Interceptor(
    {
        region: 'us-east-1',
        service: 'execute-api'
    },
    {
        accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_ACCESS_KEY
    }
);
const API_KEY = process.env.REACT_APP_API_KEY;

api.interceptors.request.use(interceptor);
unauthorizedApiInstance.interceptors.request.use(interceptor);

api.interceptors.response.use(null, (error) => {
    if (error.response && error.response.status === 401) {
        store.dispatch(logout());
    }

    return Promise.reject(error);
});

api.interceptors.request.use((config) => {
    const lang = store.getState().customization.locale || 'en';

    const { isAuth, token } = store.getState().account;

    const headers = {
        ...config.headers,
        'x-api-key': API_KEY
    };

    if (isAuth) {
        headers.authtoken = token;
    }

    if (config.method === 'get') {
        return {
            ...config,
            params: {
                ...config.params,
                lang
            },
            headers
        };
    }

    if (config.data instanceof FormData) {
        config.data.append('lang', lang);

        return {
            ...config,
            headers
        };
    }

    return {
        ...config,
        data: {
            ...config.data,
            lang
        },
        headers
    };
});

unauthorizedApiInstance.interceptors.response.use(null, (error) => {
    if (error.response && error.response.status === 401) {
        store.dispatch(logout());
    }

    return Promise.reject(error);
});

unauthorizedApiInstance.interceptors.request.use((config) => {
    const lang = store.getState().customization.locale || 'en';

    const headers = {
        ...config.headers,
        'x-api-key': API_KEY
    };

    if (config.method === 'get') {
        return {
            ...config,
            params: {
                ...config.params,
                lang
            },
            headers
        };
    }

    if (config.data instanceof FormData) {
        config.data.append('lang', lang);

        return {
            ...config,
            headers
        };
    }

    return {
        ...config,
        data: {
            ...config.data,
            lang
        },
        headers
    };
});

// ===========================|| REACT DOM RENDER  ||=========================== //

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
